
import { Box, Stack } from "@mui/material";
import { HospitalizationSection } from "./components/HospitalizationSection";
import { CathetersSection } from "./components/CathetersSection";

//YATAY;452641;18042025
function PageFour() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={4}>
        <HospitalizationSection />
        <CathetersSection />
      </Stack>
    </Box>
  );
}

export default PageFour;
